import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { BookingReportSummary as Summary } from '../types/utilisationReports';

export const BOOKING_STATUS_OPTIONS = ['pending', 'pending_payment', 'confirmed', 'rescheduled', 'in_progress', 'phlebo_assigned', 'patient_visited', 'sample_collected', 'partial_report', 'completed', 'report_added', 'report_delivered', 'cancelled', 'abandoned', 'unknown'];
const labels: Record<keyof Summary, string> = {
  total: 'Total bookings', employee: 'Employee bookings', dependent: 'Dependent bookings',
  pending: 'Pending bookings', confirmed: 'Confirmed bookings', rescheduled: 'Rescheduled bookings',
  paymentPending: 'Payment pending', completed: 'Attended or completed', cancelled: 'Cancelled bookings', abandoned: 'Abandoned bookings',
};

export default function BookingReportSummary({ summary }: { summary?: Summary }) {
  if (!summary) return null;
  return <Stack direction="row" useFlexGap flexWrap="wrap" gap={2} aria-label="Matching booking totals">
    {Object.entries(labels).map(([key, label]) => <Box key={key} sx={{ minWidth: 130, py: 1 }}>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
      <Typography variant="h6" fontWeight={700}>{summary[key as keyof Summary].toLocaleString('en-IN')}</Typography>
    </Box>)}
  </Stack>;
}
